var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"action"},[_c('div',[_c('div',{staticClass:"action__title"},[_vm._v(_vm._s(_vm.action.title))]),_c('div',{staticClass:"action__desc"},[_vm._v(_vm._s(_vm.action.desc))])]),_c('img',{attrs:{"src":require("../assets/action.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }